import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted } from "vue";

// Props
type PropTypes = {
  placement?: "top" | "bottom" | "left" | "right";
  width?: "small" | "medium" | "large";
};


export default /*#__PURE__*/_defineComponent({
  __name: 'tooltip',
  props: {
    placement: { default: "top" },
    width: { default: "small" }
  },
  setup(__props: any) {

const props = __props as { placement: "top" | "bottom" | "left" | "right", width: "small" | "medium" | "large" };



// Template ref
const tooltip_text = ref<HTMLElement>();

// Lifecycle
onMounted(() => {
  if (props.placement === "top" || props.placement === "bottom") {
    if (tooltip_text.value) {
      let right = tooltip_text.value.getBoundingClientRect().right;

      // Adjust the horizontal positioning if needed to prevent overflow.
      // istanbul ignore next
      if (right > document.body.clientWidth) {
        let correction = right - document.body.clientWidth;
        // !! IMPORTANT !! The "8" in this calculation
        // has to match the $padding SCSS variable defined
        // in this component's <style> tag.
        tooltip_text.value.style.left = `-${correction + 8}px`;
      }
    }
  }
});

return { __sfc: true,props, tooltip_text }
}

})